// Generated by purs version 0.14.4
import * as Control_Bind from "../Control.Bind/index.js";
import * as Data_Functor from "../Data.Functor/index.js";
import * as Data_Functor_Compose from "../Data.Functor.Compose/index.js";
import * as Data_Symbol from "../Data.Symbol/index.js";
import * as Effect from "../Effect/index.js";
import * as Effect_Class from "../Effect.Class/index.js";
import * as Record from "../Record/index.js";
import * as Restaumatic_Form_Final from "../Restaumatic.Form.Final/index.js";
import * as Specular_FRP_Base from "../Specular.FRP.Base/index.js";
import * as Specular_FRP_Replaceable from "../Specular.FRP.Replaceable/index.js";
import * as Specular_Ref from "../Specular.Ref/index.js";
import * as Type_Data_RowList from "../Type.Data.RowList/index.js";
import * as Type_Equality from "../Type.Equality/index.js";
var switchRecordNil = function (dictTypeEquals) {
    return {
        switchRecord: function (v) {
            return function (v1) {
                return Type_Equality.to(dictTypeEquals)({});
            };
        }
    };
};
var switchRecord = function (dict) {
    return dict.switchRecord;
};
var switchRecordI = function (dictSwitchRecord) {
    return function (dictRowToList) {
        return {
            "switch": switchRecord(dictSwitchRecord)(Type_Data_RowList.RLProxy.value)
        };
    };
};
var switchFinal = {
    "switch": (function () {
        var $21 = Control_Bind.join(Specular_FRP_Base.bindDynamic);
        var $22 = Data_Functor.map(Specular_FRP_Base.functorDynamic)(function (v) {
            return v;
        });
        return function ($23) {
            return Restaumatic_Form_Final.Final(Data_Functor_Compose.Compose($21($22($23))));
        };
    })()
};
var switchEvent = {
    "switch": Specular_FRP_Base["switch"]
};
var switchEffect = {
    "switch": (function () {
        var $24 = Control_Bind.join(Effect.bindEffect);
        var $25 = Specular_FRP_Base.readDynamic(Effect_Class.monadEffectEffect);
        return function ($26) {
            return $24($25($26));
        };
    })()
};
var switchDynamic = {
    "switch": Control_Bind.join(Specular_FRP_Base.bindDynamic)
};
var $$switch = function (dict) {
    return dict["switch"];
};
var switchFunction = function (dictSwitch) {
    return {
        "switch": function (f) {
            return function (x) {
                return $$switch(dictSwitch)(Data_Functor.map(Specular_FRP_Base.functorDynamic)(function (v) {
                    return v(x);
                })(f));
            };
        }
    };
};
var switchRecordCons = function (dictIsSymbol) {
    return function (dictLacks) {
        return function (dictCons) {
            return function (dictSwitch) {
                return function (dictSwitchRecord) {
                    return function (dictCons1) {
                        return {
                            switchRecord: function (v) {
                                return function (dyn) {
                                    return Record.insert(dictIsSymbol)()()(Data_Symbol.SProxy.value)($$switch(dictSwitch)(Data_Functor.map(Specular_FRP_Base.functorDynamic)(Record.get(dictIsSymbol)()(Data_Symbol.SProxy.value))(dyn)))(switchRecord(dictSwitchRecord)(Type_Data_RowList.RLProxy.value)(dyn));
                                };
                            }
                        };
                    };
                };
            };
        };
    };
};
var switchRef = {
    "switch": function (dyn) {
        return new Specular_Ref.Ref($$switch(switchDynamic)(Data_Functor.map(Specular_FRP_Base.functorDynamic)(Specular_Ref.value)(dyn)), $$switch(switchFunction(switchEffect))(Data_Functor.map(Specular_FRP_Base.functorDynamic)(Specular_Ref.modify(Effect_Class.monadEffectEffect))(dyn)));
    }
};
var dynamicSwitch = function (dictSwitch) {
    return function (dictMonadReplace) {
        return function (dictMonadFRP) {
            var $27 = Data_Functor.map(((((dictMonadFRP.MonadCleanup1()).Monad0()).Bind1()).Apply0()).Functor0())($$switch(dictSwitch));
            var $28 = Specular_FRP_Replaceable.dynamic(dictMonadReplace)(dictMonadFRP);
            return function ($29) {
                return $27($28($29));
            };
        };
    };
};
export {
    $$switch as switch,
    dynamicSwitch,
    switchRecord,
    switchDynamic,
    switchEvent,
    switchEffect,
    switchFunction,
    switchRef,
    switchFinal,
    switchRecordI,
    switchRecordNil,
    switchRecordCons
};
//# sourceMappingURL=index.js.map
